import Vue from 'vue';
import { Portal } from '@linusborg/vue-simple-portal';

Vue.component('Portal', Portal);
